import React, { useEffect, useState } from "react";
import styles from "./Drafts.module.scss";
import LayoutHeader from "@features/common/header/layoutHeader/LayoutHeader";
import DraftsTable from "@features/drafts/draftsTable/DraftsTable";
import { useFetchDraftsQuery } from "@features/drafts/draftsAPI";
import { DraftData } from "interfaces/common.interface";
import { useAppSelector } from "@redux/hooks";
import { selectDashboardData } from "@redux/slices/CommonSlice";

const Drafts: React.FC = () => {
  const [draftsData, setDraftsData] = useState<DraftData[]>([]);

  const dashboardData = useAppSelector(selectDashboardData);
  const { data: fetchedDrafts, isLoading: draftsLoading } =
    useFetchDraftsQuery();
  useEffect(() => {
    if (fetchedDrafts) {
      setDraftsData(fetchedDrafts?.data ?? []);
    }
  }, [fetchedDrafts]);

  return (
    <div className={styles["page-container"]}>
      <LayoutHeader
        headerTitle="Drafts"
        subHeader={`(${fetchedDrafts?.total_count || 0} items)`}
        amount={dashboardData?.amount || 0}
        currency={dashboardData?.currency || "AED"}
      />
      <DraftsTable tableData={draftsData} darfsTableLoading={draftsLoading} />
    </div>
  );
};

export default Drafts;
